import { setDateStatus } from "../../../components/trip-dates/script.js";
setDateStatus();
